import React, { Component } from 'react';
import { Form, Input, Checkbox, Spin } from 'antd';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'loadsh/isEmpty';
import {
  Container,
  formLayout,
  formValidateMessages,
  H1,
  H2,
  FormWrapper,
  SecondaryButton,
  SpaceBetween,
  PrimaryButtonV2,
  ModalV2,
  TipBox,
  AddFormItemLabel,
  AddSaveHint,
  device,
} from 'utils';
import { ProjectsActions } from 'redux/actions';
import { LoginFormV2, RegisteredForm } from 'components';
import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import pickBy from 'loadsh/pickBy';
import identity from 'loadsh/identity';
import styled from '@emotion/styled/macro';
import { ReceiptIcon } from 'images';
import { parse } from 'papaparse';

const FormItem = Form.Item;

const CurrencyWrapper = styled.div`
  .custom-currency-input {
    position: relative;

    &::before {
      content: 'EUR';
      position: absolute;
      left: 0;
      top: 0;
      width: 54px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 10px 0px 0px 10px;
      color: #535862 !important;
      font-size: 16px;
      padding-top: 2px;
      background-color: #fff;
      border: 1px solid #d9d9d9;
      z-index: 2;
    }

    input {
      width: 100%;
      height: 44px;
      padding-left: 64px;
      border-radius: 10px !important;
      box-sizing: border-box;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      background-color: #fff;
      border: 1px solid #d9d9d9;
      transition: all 0.3s;
      position: relative;
      z-index: 1;
    }
    input:hover {
      border-color: #1890ff;
    }
    input:focus-visible {
      border-color: #1890ff;
      outline: none;
    }
  }

  .custom-currency-input.extra-margin::before {
    margin-top: 32px;

    @media ${device.maxLaptop} {
      margin-top: 33px;
    }
  }
`;

const ReceiptCheckBox = styled(Checkbox)`
  span {
    padding: 0;
  }

  .ant-checkbox {
    margin-left: auto !important;
  }
`;

class FundingGoal extends Component {
  static propTypes = {
    updateDraft: PropTypes.func.isRequired,
    project: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    errors: PropTypes.object.isRequired,
    projectId: PropTypes.string,
    currentStep: PropTypes.number.isRequired,
    setCanMove: PropTypes.func.isRequired,
    showModal: PropTypes.bool.isRequired,
    selectedStep: PropTypes.number.isRequired,
    setSubmitFromModal: PropTypes.func.isRequired,
    handleExitEditForm: PropTypes.func.isRequired,
    editProject: PropTypes.bool.isRequired,
  };
  state = {
    showLoginModal: false,
    showRegisteredModal: false,
    showDynamicGoal: false,
    currentGoal: null,
    currentFinalGoal: null,
    donationReceiptPossible: false,
  };

  componentDidMount() {
    const { project, projectId, updateDraft } = this.props;
    projectId && updateDraft(projectId, {});
    if (!project) {
      const savedData = sessionStorage.getItem('fundingData');
      const parsedData = savedData ? JSON.parse(savedData) : {};
      this.setState({
        currentFinalGoal: parsedData.finalGoal,
        showDynamicGoal: parsedData.goal ? true : false,
        currentGoal: parsedData.goal,
        donationReceiptPossible: parsedData.donation_receipts_possible
          ? true
          : false,
      });
      return;
    }

    if (project?.fundingTarget) {
      this.setState({
        currentFinalGoal: project.fundingTarget.finalGoal,
        showDynamicGoal: project.fundingTarget.goal ? true : false,
        currentGoal: project.fundingTarget.goal,
        donationReceiptPossible: this.props.donation_receipts_possible
          ? true
          : false,
      });
    }
  }

  handelCloseLoginModal = () => {
    this.setState({ showLoginModal: false });
  };
  handelCloseRegisteredModal = () => {
    this.setState({ showRegisteredModal: false });
  };
  handleDynamicGoal = (e) => {
    this.setState({ showDynamicGoal: e.target.checked });
  };
  onFinish = (values) => {
    const { updateDraft, projectId, currentStep, setCanMove, editProject } =
      this.props;
    const client = localStorage.getItem('client');
    const uid = localStorage.getItem('uid');
    const access = localStorage.getItem('access-token');
    const user = localStorage.getItem('user');
    const isLoggedIn =
      user && !isEmpty(user) && access && uid && client ? true : false;
      //true;
    if (!values.enable_dynamic_goals) {
      values.goal = null;
    }
    if (isLoggedIn) {
      if (projectId) {
        updateDraft(projectId, values, currentStep);
        sessionStorage.removeItem('fundingData');
      } else {
        sessionStorage.setItem('fundingData', JSON.stringify(values));
      }
      setCanMove(true);
      if (editProject) this.props.handleSteps(5);
      else this.props.handleSteps(4);
    } else {
      this.setState({
        showLoginModal: true,
        onLoginSuccess: () => {
          sessionStorage.setItem('fundingData', JSON.stringify(values));
          this.props.handleSteps(4);
        },
        onRegisterSuccess: () => {
          this.setState({ showLoginModal: false });
          this.setState({ showRegisteredModal: true });
        },
      });
    }
  };

  onReturn = () => {
    if (this.props.editProject) this.props.handleExitEditForm();
    else this.props.handleSteps(2);
  };

  render() {
    const { project, loading, setCanMove, projectId, editProject } = this.props;

    const savedData = sessionStorage.getItem('fundingData');
    const parsedData = savedData ? JSON.parse(savedData) : {};

    const client = localStorage.getItem('client');
    const uid = localStorage.getItem('uid');
    const access = localStorage.getItem('access-token');
    const user = localStorage.getItem('user');
    const isLoggedIn =
      user && !isEmpty(user) && access && uid && client ? true : false;

    const initialValues = projectId
      ? pickBy(project.fundingTarget, identity)
      : parsedData || {};
    initialValues.enable_dynamic_goals = this.state.showDynamicGoal;

    return (
      <Container className="inside-form-container">
        <Spin spinning={loading}>
          <H1>Lass uns Ziele setzen.</H1>
          {!loading && (
            <Form
              {...formLayout}
              name="project-details"
              onFinish={this.onFinish}
              validateMessages={formValidateMessages}
              onChange={() => setCanMove(false)}
              initialValues={initialValues}
            >
              <H2>Wieviel möchtest du sammeln?</H2>
              <FormWrapper>
                <>
                  <CurrencyWrapper>
                    <div className="custom-currency-input extra-margin">
                      <FormItem
                        name="final_goal"
                        label={<AddFormItemLabel>Gesamtziel</AddFormItemLabel>}
                        required={false}
                        extra="Mindestens 100,00 €"
                        rules={[
                          {
                            required: true,
                            message: 'Gesamtziel ist erforderlich',
                          },
                        ]}
                        initialValue={this.state.currentFinalGoal}
                      >
                        <Input
                          type="number"
                          min={100}
                          placeholder="Betrag eingeben"
                          step=".01"
                        />
                      </FormItem>
                    </div>
                  </CurrencyWrapper>
                </>
              </FormWrapper>

              <H2>Dynamisches Etappenziel</H2>
              <p>
                Dein Zielbetrag wird automatisch erhöht, sobald Unterstützungen
                eingehen, sodass du immer ein aktuelles Zwischenziel hast. So
                bleibt dein Projekt immer in Bewegung und motiviert deine
                Unterstützer.
              </p>

              <FormWrapper>
                <>
                  <FormItem name="enable_dynamic_goals" valuePropName="checked">
                    <Checkbox
                      onChange={this.handleDynamicGoal}
                      checked={
                        parsedData.enable_dynamic_goals ||
                        this.state.showDynamicGoal
                      }
                    >
                      Ich möchte mein erstes Etappenziel selbst bestimmen.
                    </Checkbox>
                  </FormItem>
                  {(parsedData.enable_dynamic_goals ||
                    this.state.showDynamicGoal) && (
                    <CurrencyWrapper>
                      <div className="custom-currency-input">
                        <FormItem
                          name="goal"
                          rules={[
                            ({ getFieldValue }) => ({
                              validator(_, value) {
                                if (
                                  Number(value) >
                                  Number(getFieldValue(['final_goal']))
                                ) {
                                  return Promise.reject(
                                    'Das erste Etappenziel muss kleiner als das Gesamtziel sein.'
                                  );
                                } else {
                                  return Promise.resolve();
                                }
                              },
                            }),
                          ]}
                          initialValue={this.state.currentGoal}
                        >
                          <Input
                            type="number"
                            min={100}
                            placeholder="Erstes Etappenziel eingeben"
                            step=".01"
                          />
                        </FormItem>
                      </div>
                    </CurrencyWrapper>
                  )}
                </>
              </FormWrapper>

              <H2 style={{ paddingBottom: '8px' }}>Belege</H2>
              <FormWrapper style={{ paddingTop: '0' }}>
                <>
                  <TipBox
                    style={{
                      border: `${
                        this.state.donationReceiptPossible
                          ? '2px solid #669F2A'
                          : '1px solid #D5D7DA'
                      }`,
                      borderRadius: '12px',
                    }}
                  >
                    <img
                      style={{
                        width: '32px',
                        margin: '16px',
                        alignSelf: 'flex-start',
                      }}
                      src={ReceiptIcon}
                      alt="Submission icon"
                    />
                    <FormItem
                      name="donation_receipts_possible"
                      extra="Wenn deine Organisation gemeinnützig ist, können Unterstützer Spendenquittungen von dir erhalten. Die Ausstellung der Spendenquittung liegt in deiner Verantwortung."
                      valuePropName="checked"
                      style={{
                        paddingTop: '8px',
                        paddingRight: '16px',
                      }}
                    >
                      <ReceiptCheckBox
                        checked={project.donation_receipts_possible}
                        onChange={(e) =>
                          this.setState({
                            donationReceiptPossible: e.target.checked,
                          })
                        }
                        style={{
                          display: 'flex',
                          flexDirection: 'row-reverse',
                          justifyContent: 'flex-end',
                          width: '100%',
                        }}
                      >
                        Ich kann Spendenquittungen ausstellen
                      </ReceiptCheckBox>
                    </FormItem>
                  </TipBox>
                </>
              </FormWrapper>

              {editProject && <AddSaveHint />}

              <FormItem>
                <SpaceBetween>
                  <SecondaryButton
                    type="button"
                    minWidth="120px"
                    onClick={this.onReturn}
                  >
                    {editProject ? (
                      <p>Zurück zur Projektübersicht</p>
                    ) : (
                      <>
                        <ArrowLeftOutlined />
                        <p>Zurück</p>
                      </>
                    )}
                  </SecondaryButton>

                  <PrimaryButtonV2
                    type="primary"
                    htmltype="submit"
                    minWidth="120px"
                    id="submit-button"
                  >
                    {editProject ? (
                      <p>Speichern*</p>
                    ) : (
                      <>
                        <p>Weiter</p>
                        <ArrowRightOutlined />
                      </>
                    )}
                  </PrimaryButtonV2>
                </SpaceBetween>
              </FormItem>
            </Form>
          )}
        </Spin>
        <ModalV2
          showModal={isLoggedIn ? false : this.state.showLoginModal}
          handelCloseModal={this.handelCloseLoginModal}
        >
          {this.state.showLoginModal && (
            <LoginFormV2
              onLoginSuccess={this.state.onLoginSuccess}
              onRegisterSuccess={this.state.onRegisterSuccess}
            />
          )}
        </ModalV2>
        <ModalV2
          showModal={this.state.showRegisteredModal}
          handelCloseModal={this.handelCloseRegisteredModal}
        >
          {this.state.showRegisteredModal && <RegisteredForm />}
        </ModalV2>
      </Container>
    );
  }
}

const mapStateToProps = (state) => {
  const { project, loading, errors, currentStep } = state.projects;
  return {
    project,
    loading,
    errors,
    currentStep,
  };
};

const mapDispatchToProps = (dispatch) => ({
  handleSteps: (step) => dispatch(ProjectsActions.handleSteps(step)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FundingGoal);
